export default "__VITE_ASSET__d63c0f6e__"